import { datadogRum } from '@datadog/browser-rum';

type CheckoutErrorLogTypes =
    | 'fatal'
    | 'vault'
    | 'submit'
    | 'shipping'
    | 'sidemark'
    | 'offer'
    | 'applepay'
    | 'shipmentquote'
    | 'ach'
    | 'paypal'
    | 'taxexemption'
    | 'chargeCurrency'
    | 'vat'
    | 'loadEvent'
    | 'confirmation'
    | 'guestemail';

export function logCheckoutError(
    error: unknown,
    type: CheckoutErrorLogTypes,
    additionalInfo?: Record<string, string>
): void {
    datadogRum.addError(error, {
        checkoutErrorType: type,
        // @ts-expect-error
        traceGuid: error?.traceGuid,
        ...additionalInfo,
    });
    // eslint-disable-next-line no-console
    console.error(error);
}
